import { ATTRIBUTES_VALIDATION_STATE } from "fe2/Components/UIKit/ClanCreate/Constants";
import { clanNameTag } from "./ReducerCreators";
import { START_RENAMING_CLAN, STOP_RENAMING_CLAN, ERROR_RENAMING_CLAN, SET_INITIAL_STATE_RENAMING_CLAN, SET_STATUS_URL_RENAMING_CLAN, UPDATE_RENAMING_CLAN_FIELD_VALUE, START_CHECK_AVAILABILITY_CLAN_RENAMING, START_CHECK_CLAN_RENAMING_STATUS, FINISH_CHECK_AVAILABILITY_CLAN_RENAMING, FINISH_CHECK_CLAN_RENAMING_STATUS } from "../Actions/ActionClanRename";

const clanRenameInitialState = {
  tag: {
    value: null,
    available: ATTRIBUTES_VALIDATION_STATE.AVAILABLE,
    isValidating: false,
    error: null
  },
  name: {
    value: null,
    available: ATTRIBUTES_VALIDATION_STATE.AVAILABLE,
    isValidating: false,
    error: null
  },
  isProcessing: false,
  isCheckingStatus: false,
  error: null,
  statusUrl: null
};

const actionTypes = {
  startOperation: START_RENAMING_CLAN,
  stopOperation: STOP_RENAMING_CLAN,
  updateFieldValue: UPDATE_RENAMING_CLAN_FIELD_VALUE,
  startCheckAvailability: START_CHECK_AVAILABILITY_CLAN_RENAMING,
  finishCheckAvailability: FINISH_CHECK_AVAILABILITY_CLAN_RENAMING,
  updateError: ERROR_RENAMING_CLAN,
  setInitialState: SET_INITIAL_STATE_RENAMING_CLAN,
  setStatusUrl: SET_STATUS_URL_RENAMING_CLAN,
  startCheckingStatus: START_CHECK_CLAN_RENAMING_STATUS,
  finishCheckingStatus: FINISH_CHECK_CLAN_RENAMING_STATUS
};

export const clanRename = clanNameTag(actionTypes, clanRenameInitialState);